import type { SettingsListItemProps } from 'global/types/props'
import Icon from 'shared/components/icon'

export const SettingsListItem = ({ name, icon, value, onClick }: SettingsListItemProps) => (
  <button
    className='flex flex-row gap-2 items-center text-left w-full border-b border-border last:border-b-0 py-3'
    type='button'
    onClick={onClick}
  >
    <Icon icon={icon} size={20} />
    <div className='flex-1'>{name}</div>
    {Boolean(value) && <>{value}</>}
    {onClick && <Icon icon='chevron-right' size={20} />}
  </button>
)
